import { render, staticRenderFns } from "./partnerRecruitment.vue?vue&type=template&id=8aaaf0b0&scoped=true&"
import script from "./partnerRecruitment.vue?vue&type=script&lang=js&"
export * from "./partnerRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./partnerRecruitment.vue?vue&type=style&index=0&id=8aaaf0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aaaf0b0",
  null
  
)

export default component.exports